<!--
 * @Author: mazhigang
 * @Date: 2023-09-10 15:27:44
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-10-28 16:51:46
-->
<template>
  <div style="background: #FAFCFF;overflow-x: scroll;">
    <div class="pageTop">
      <div class="topBox">
        <pageTop :color="'#000'"></pageTop>
      </div>
    </div>
    <div style="padding-top: 65px;box-sizing: border-box;">
      <div class="topBanner">
        <img src="../../../static/ourBanner.png" alt="" style="width: 100%;" />
        <div style="position: absolute;top: 50px;left: 28%;">
          <div style="font-size: 28px;font-weight: bold;">
            关于我们
          </div>
          <div class="solid"></div>
          <div style="font-size: 16px;">ABOUT US</div>
        </div>
      </div>
      <div class="content">
        <div style="margin-top: 24px;">
          <div class="boxTitle">
            <img
              src="../../../static/titleIcon.png"
              alt=""
              style="width: 31px;height: 25px;z-index: 1;margin-right: 10px;margin-top: 4px;"
            />
            <div>企业介绍</div>
          </div>
          <div
            style="display: flex;align-items: center;justify-content: space-between;margin-top: 24px;"
          >
            <img
              src="../../../static/ourImg.png"
              alt=""
              style="width: 607px;height: 428px;"
            />
            <div style="margin-right: 50px;">
              <div
                style="font-size: 14px;width: 511px;margin-bottom: 24px;line-height: 40px;color: #363B4D;"
              >
                咖德蔚来总部坐落于美丽的北京亦庄经济开发区，主创团队均来自国内外知名互联网大厂；公司长期深耕保安数字化服务领域，以“科技赋能保安行业”的战略践行“一次保安，尽显忠诚”为公司使命，更好地承担社会责任，更多地创造社会价值，坚持科技创新、AI
                赋能，助力保安服务行业数字化发展，与客户、保安共建守护生态。
              </div>
              <div class="textBg">
                <div style="font-size: 16px;color: #105FFF;font-weight: 600;">
                  企业愿景
                </div>
                <div style="margin-top: 20px;line-height: 30px;">
                  咖德蔚来希望通过“技术创新”+“AI大模型”驱动，打造保安领域的专业招聘平台，进一步助力保安行业供需的数字化升级。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottonBg">
        <div class="qiye">
          <div class="boxTitle">
            <div>企业合作</div>
          </div>
          <div style="margin-top: 20px;font-size: 16px;">
            咖德蔚来诚邀全国各城市具备相关资源（如本地企业资源、安保团队基础、行业渠道）的合作伙伴，共同拓展区域安保市场，合作形式包括：​
          </div>
          <div
            style="display: flex;justify-content: space-between;margin-top: 10px;"
          >
            <div class="modelBox">
              <div style="display: flex;justify-content: space-between;">
                <div class="jiao">
                  <div style="font-weight: bold;font-size: 36px;">01</div>
                  <div style="margin-top: 10px;font-weight: 600;">
                    合规协同合作
                  </div>
                </div>
                <img
                  src="../../../static/icon1.png"
                  alt=""
                  style="width: 40px;height: 40px;margin: 24px;"
                />
              </div>
              <div style="color: #7C8294;margin:0 20px;font-size: 14px;">
                配合地方安防工作部署，推动安保服务与公共安全防控协同推进
              </div>
            </div>
            <div class="modelBox">
              <div style="display: flex;justify-content: space-between;">
                <div class="jiao">
                  <div style="font-weight: bold;font-size: 36px;">02</div>
                  <div style="margin-top: 10px;font-weight: 600;">
                    区域独家合作伙伴
                  </div>
                </div>
                <img
                  src="../../../static/icon1.png"
                  alt=""
                  style="width: 40px;height: 40px;margin: 24px;"
                />
              </div>
              <div style="color: #7C8294;margin:0 20px;font-size: 14px;">
                负责指定城市 / 区域的业务拓展、客户维护
              </div>
            </div>
            <div class="modelBox">
              <div style="display: flex;justify-content: space-between;">
                <div class="jiao">
                  <div style="font-weight: bold;font-size: 36px;">03</div>
                  <div style="margin-top: 10px;font-weight: 600;">
                    项目合作商
                  </div>
                </div>
                <img
                  src="../../../static/icon1.png"
                  alt=""
                  style="width: 40px;height: 40px;margin: 24px;"
                />
              </div>
              <div style="color: #7C8294;margin:0 20px;font-size: 14px;">
                针对具体行业客户或大型项目开展联合服务，共享收益
              </div>
            </div>
          </div>
          <div style="margin-top: 30px; margin-bottom: 20px; color: #070D2F;">
            咖德蔚来提供资源：
          </div>
          <div
            style="display: flex;justify-content: space-between;margin-top: 10px;"
          >
            <div class="modelBox1">
              <img
                src="../../../static/icon2.png"
                alt=""
                style="width: 32px;height: 32px;margin-right: 16px;"
              />
              <div>全流程的合作支撑（产品、技术、方案、谈判等）</div>
            </div>
            <div class="modelBox1">
              <img
                src="../../../static/icon2.png"
                alt=""
                style="width: 32px;height: 32px;margin-right: 16px"
              />
              <div>市场化合作收益分成</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagebottom></pagebottom>
    <pageleft></pageleft>
  </div>
</template>
<script>
import pageTop from "../../components/pageTitle.vue";
import pageleft from "../../components/leftCode.vue";
import pagebottom from "../../components/pagebottom.vue";
export default {
  components: {
    pageTop,
    pageleft,
    pagebottom
  },
  data() {
    return {
      center: { lng: 116.51301, lat: 39.80113 },
      zoom: 15
    };
  },
  created() {},
  methods: {}
};
</script>
<style scoped>
@media (max-width: 1920px) {
  .content {
    transform: scale(0.9);
  }
  .qiye {
    transform: scale(0.9);
  }
}
.textBg {
  width: 511px;
  height: 156px;
  background-image: url("../../../static/ourBg.png");
  background-size: 100% 100%;
  padding: 20px 20px;
  box-sizing: border-box;
}
.content {
  width: 1200px;
  margin: 0 auto;
}
.topBox {
  width: 100%;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(155, 155, 155, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.topBanner {
  width: 100%;
  position: relative;
}
.solid {
  width: 72px;
  height: 6px;
  background: linear-gradient(270deg, rgba(238, 238, 238, 0) 0%, #4b74fe 100%);
  border-radius: 3px;
  margin: 14px 0 14px 0;
}
.bottonBg {
  width: 100%;
  background-image: url("../../../static/bottonBg.png");
  background-size: 100% 100%;
  padding: 10px 0;
  box-sizing: border-box;
  margin-top: 30px;
}
.qiye {
  width: 1200px;
  height: 509px;
  margin: 0 auto;
  background-image: url("../../../static/qiyeBg1.png");
  background-size: 100% 100%;
  padding: 30px 24px;
  box-sizing: border-box;
  margin-bottom: 60px;
}
.boxTitle {
  font-size: 25px;
  font-weight: bold;
  color: #00122c;
  line-height: 29px;
  display: flex;
  align-content: center;
  justify-content: center;
}
.boxTitle img {
  z-index: -1;
}
.modelBox1 {
  width: 562px;
  height: 80px;
  background: linear-gradient(
    180deg,
    #f0f5ff 1.98%,
    #fafcfe 74.29%,
    #fefeff 100%
  );
  box-shadow: 0px 2px 25px 0px rgba(27, 51, 112, 0.1);
  border-radius: 8px;
  border: 2px solid #ffffff;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  padding: 20px 20px;
  box-sizing: border-box;
}
.jiao {
  width: 226px;
  height: 110px;
  background-image: url("../../../static/yinyin.png");
  background-size: 100% 100%;
  padding: 20px 20px;
  box-sizing: border-box;
}
.modelBox {
  width: 375px;
  height: 170px;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 5px 11px 0px rgba(115, 119, 133, 0.1);
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/view/about/about.vue